import { GalleryPresetDto } from '@picflow/types';

export interface StandardGalleryPreset
  extends Omit<GalleryPresetDto, 'created_at' | 'updated_at' | 'deleted_at' | 'tenant' | 'type'> {
  backend_name: string;
}

export const standardPresets: StandardGalleryPreset[] = [
  {
    backend_name: 'View-Only',
    is_default: false,
    id: 'view-only',
    name: 'View-Only',
    primary_color: null,
    requires_user_identification: false,
    contacts_hidden: false,
    save_camera_metadata: false,
    email_notifications: false,
    download_single_asset: false,
    picflow_branding_enabled: true,
    client_advanced_mode_enabled: false,
    download_full_gallery: false,
    download_media_size: 999999,
    approval_limits: null,
    enabled_feedback_options: [],
    color_mode: 'light',
    color_labels: [
      {
        color: 'red',
        name: 'Red',
        active: true,
      },
      {
        color: 'orange',
        name: 'Orange',
        active: true,
      },
      {
        color: 'blue',
        name: 'Blue',
        active: true,
      },
      {
        color: 'purple',
        name: 'Purple',
        active: true,
      },
      {
        color: 'green',
        name: 'Green',
        active: true,
      },
    ],
    version_history_enabled: false,
    visible: true,
    client_layout_mode_enabled: true,
    watermark: null,
    default_title_typography: {},
    default_paragraph_typography: {},
    layout_background_color: null,
    enabled_gallery_statuses: ['no_status'],
    enabled_asset_statuses: ['approved', 'in_progress', 'needs_review', 'no_status', 'rejected'],
    approved_downloads_only: false,
  },
  {
    backend_name: 'Download',
    is_default: false,
    id: 'download',
    name: 'Download',
    primary_color: null,
    requires_user_identification: false,
    contacts_hidden: false,
    save_camera_metadata: true,
    email_notifications: false,
    download_single_asset: true,
    picflow_branding_enabled: true,
    client_advanced_mode_enabled: false,
    download_full_gallery: true,
    download_media_size: 999999,
    approval_limits: null,
    enabled_feedback_options: [],
    color_mode: 'light',
    color_labels: [
      {
        color: 'red',
        name: 'Red',
        active: true,
      },
      {
        color: 'orange',
        name: 'Orange',
        active: true,
      },
      {
        color: 'blue',
        name: 'Blue',
        active: true,
      },
      {
        color: 'purple',
        name: 'Purple',
        active: true,
      },
      {
        color: 'green',
        name: 'Green',
        active: true,
      },
    ],
    version_history_enabled: false,
    visible: true,
    client_layout_mode_enabled: true,
    watermark: null,
    default_title_typography: {},
    default_paragraph_typography: {},
    layout_background_color: null,
    enabled_gallery_statuses: ['no_status'],
    enabled_asset_statuses: ['approved', 'in_progress', 'needs_review', 'no_status', 'rejected'],
    approved_downloads_only: false,
  },
  {
    backend_name: 'Review',
    is_default: false,
    id: 'review',
    name: 'Review',
    primary_color: null,
    requires_user_identification: false,
    contacts_hidden: false,
    save_camera_metadata: true,
    email_notifications: false,
    download_single_asset: true,
    picflow_branding_enabled: true,
    client_advanced_mode_enabled: true,
    download_full_gallery: true,
    download_media_size: 999999,
    approval_limits: null,
    enabled_feedback_options: ['favourite', 'comment', 'annotation', 'status'],
    color_mode: 'light',
    color_labels: [
      {
        color: 'red',
        name: 'Red',
        active: true,
      },
      {
        color: 'orange',
        name: 'Orange',
        active: true,
      },
      {
        color: 'blue',
        name: 'Blue',
        active: true,
      },
      {
        color: 'purple',
        name: 'Purple',
        active: true,
      },
      {
        color: 'green',
        name: 'Green',
        active: true,
      },
    ],
    version_history_enabled: false,
    visible: true,
    client_layout_mode_enabled: true,
    watermark: null,
    default_title_typography: {},
    default_paragraph_typography: {},
    layout_background_color: null,
    enabled_gallery_statuses: ['no_status'],
    enabled_asset_statuses: ['approved', 'no_status'],
    approved_downloads_only: false,
  },
  {
    backend_name: 'Workflow',
    is_default: false,
    id: 'workflow',
    name: 'Workflow',
    primary_color: null,
    requires_user_identification: true,
    contacts_hidden: false,
    save_camera_metadata: true,
    email_notifications: false,
    download_single_asset: true,
    picflow_branding_enabled: true,
    client_advanced_mode_enabled: true,
    download_full_gallery: true,
    download_media_size: 999999,
    approval_limits: null,
    enabled_feedback_options: ['favourite', 'comment', 'color_label', 'annotation'],
    color_mode: 'light',
    color_labels: [
      {
        color: 'red',
        name: 'Red',
        active: true,
      },
      {
        color: 'orange',
        name: 'Orange',
        active: true,
      },
      {
        color: 'blue',
        name: 'Blue',
        active: true,
      },
      {
        color: 'purple',
        name: 'Purple',
        active: true,
      },
      {
        color: 'green',
        name: 'Green',
        active: true,
      },
    ],
    version_history_enabled: true,
    visible: true,
    client_layout_mode_enabled: true,
    watermark: null,
    default_title_typography: {},
    default_paragraph_typography: {},
    layout_background_color: null,
    enabled_gallery_statuses: ['no_status'],
    enabled_asset_statuses: ['approved', 'in_progress', 'needs_review', 'no_status', 'rejected'],
    approved_downloads_only: false,
  },
];
